export default "__VITE_ASSET__oHC2dKtw__"